import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../account/components/ProtectedRoute";
import { LoginPage } from "../account/pages/LoginPage";
import { AdminLayout } from "./components/AdminLayout";
import { AdminAnnouncementsPage } from "./pages/AdminAnnouncementsPage";
import { AdminAssessmentsPage } from "./pages/AdminAssessmentsPage";
import { AdminAuditLogPage } from "./pages/AdminAuditLogPage";
import { AdminContentPage } from "./pages/AdminContentPage";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { AdminLeadsPage } from "./pages/AdminLeadsPage";
import { AdminMembershipsPage } from "./pages/AdminMembershipsPage";
import { AdminPaymentsPage } from "./pages/AdminPaymentsPage";
import { AdminPlayersPage } from "./pages/AdminPlayersPage";
import { AdminProgramsPage } from "./pages/AdminProgramsPage";
import { AdminSchedulePage } from "./pages/AdminSchedulePage";
import { AdminSettingsPage } from "./pages/AdminSettingsPage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { PlayerReportPage } from "../dashboard/pages/PlayerReportPage";

export function AdminRoutes() {
  return (
    <Routes>
      <Route path="/admin/login" element={<LoginPage portal="admin" />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute allow={["admin", "superadmin"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboardPage />} />
        <Route path="programs" element={<AdminProgramsPage />} />
        <Route path="memberships" element={<AdminMembershipsPage />} />
        <Route path="assessments" element={<AdminAssessmentsPage />} />
        <Route path="players" element={<AdminPlayersPage />} />
        <Route path="players/:playerId/report" element={<PlayerReportPage />} />
        <Route path="schedule" element={<AdminSchedulePage />} />
        <Route path="payments" element={<AdminPaymentsPage />} />
        <Route path="content" element={<AdminContentPage />} />
        <Route path="announcements" element={<AdminAnnouncementsPage />} />
        <Route path="leads" element={<AdminLeadsPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="audit-log" element={<AdminAuditLogPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route path="*" element={<AdminDashboardPage />} />
      </Route>
    </Routes>
  );
}
